import React from "react";
import { Container } from "./styles";

const SendWinks = React.forwardRef(({ visible, setTexto, texto }, ref) => {
    const emoticonslist = Array.from({ length: 63 }, (_, i) => `${i + 1}`);

    // Dynamically import all PNGs in this folder
    const importAll = (r) => {
        let images = {};
        r.keys().forEach((key) => {
            const name = key.replace('./', '').replace('.png', '');
            images[name] = r(key);
        });
        return images;
    };

    const emoticonImages = importAll(require.context('./assets', false, /\.png$/));

    const handleSendWink = (num) => {
        setTexto(`${texto}<img src="${emoticonImages[num]}" alt="emoticon" />`);
    };

    const emoticons = emoticonslist.map((elem) => (
        <button key={elem}>
            <img
                src={emoticonImages[elem]}
                alt={`emoticon-${elem}`}
                onClick={() => handleSendWink(elem)}
            />
        </button>
    ));

    return (
        <Container visible={visible} ref={ref}>
            {emoticons}
        </Container>
    );
});

export default SendWinks;
